import { getUserToken } from '@go-client/lib/auth';
import { userContract } from '../../../../shared/contracts/user';
import { getApiUrlv2, initApiClient } from '@go-client/lib/api';

export const userClient = initApiClient(userContract, {
  baseUrl: getApiUrlv2(),
  baseHeaders: {
    'Content-Type': 'application/json',
    authorization: () => `Bearer ${getUserToken()}`,
  },
});
